import { Page, SparkLiquidityLayerIcon } from '@/components';
import { Flex, Heading, Text } from '@blockanalitica/ui';
import _ from 'lodash';
import { useParams } from 'react-router';
import AllocatedTable from '../../assets/AllocatedTable';
import AssetsTable from '../../assets/AssetsTable';
import PSM3Table from '../../assets/PSM3Table';
import PolTable from '../../assets/PolTable';

export default function SLLNetworkAssetsPage() {
  const { network } = useParams() as {
    network: string;
  };

  const title = _.capitalize(network);

  return (
    <Page
      title={
        <Flex alignItems="center" gap="s">
          <SparkLiquidityLayerIcon size="4" />
          <Heading>Spark Liquidity Layer</Heading>
        </Flex>
      }>
      <Heading size="2">{title} Liquidity provisions</Heading>
      <AllocatedTable network={network} />

      <Flex flexDirection="row" gap="2xs" alignItems="baseline">
        <Heading size="2">{title} Assets</Heading>
        <Text color="muted" fontSize="-1">
          (Assets in ALM proxy)
        </Text>
      </Flex>
      <AssetsTable network={network} />

      <Flex flexDirection="row" gap="2xs" alignItems="baseline">
        <Heading size="2">{title} PSM3</Heading>
        <Text color="muted" fontSize="-1">
          (Only USDC is counted for Allocated Assets)
        </Text>
      </Flex>
      <PSM3Table network={network} />
      <Flex flexDirection="row" gap="2xs" alignItems="baseline">
        <Heading size="2">{title} Idle Assets</Heading>
        <Text color="muted" fontSize="-1">
          (This assets are not counted for Allocated Assets)
        </Text>
      </Flex>
      <PolTable network={network} />
    </Page>
  );
}
